import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { doc, setDoc, serverTimestamp } from 'firebase/firestore'
import { auth, db } from '@/lib/firebase'
import { useAuthStore } from '@/stores/authStore'

const SEGMENTS = ['Restaurante/Alimentação','Clínica/Saúde','Salão/Beleza','Academia/Fitness','Loja/Varejo','Imobiliária','Educação/Cursos','Outro']

export default function OnboardingPage() {
  const navigate = useNavigate()
  const { refreshProfile } = useAuthStore()
  const [businessName, setBusinessName] = useState('')
  const [segment, setSegment] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    const currentUser = auth.currentUser
    if (!currentUser) {
      setError('Sessão expirada. Recarregue a página.')
      return
    }
    setLoading(true)
    setError('')
    try {
      await setDoc(doc(db, 'users', currentUser.uid), {
        uid: currentUser.uid,
        email: currentUser.email,
        businessName,
        segment,
        plan: 'free',
        onboardingCompleted: true,
        createdAt: serverTimestamp(),
      })
      await refreshProfile()
      navigate('/dashboard')
    } catch (err: any) {
      console.error(err)
      setError('Erro ao salvar: ' + err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-white mb-2">Bem-vindo ao Dikis AI! 🎉</h1>
      <p className="text-gray-400 mb-8">Conta pra gente sobre o seu negócio</p>

      {error && (
        <div className="bg-red-500/10 border border-red-500/30 text-red-400 rounded-lg px-4 py-3 mb-6 text-sm">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm text-gray-400 mb-1">Nome do negócio</label>
          <input
            type="text"
            value={businessName}
            onChange={e => setBusinessName(e.target.value)}
            required
            className="w-full bg-white/5 border border-white/10 text-white rounded-xl px-4 py-3 focus:outline-none focus:border-indigo-500 transition-colors"
            placeholder="Ex: Pizzaria do João"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-400 mb-2">Segmento</label>
          <div className="grid grid-cols-2 gap-2">
            {SEGMENTS.map(s => {
              const active = segment === s
              return (
                <button
                  key={s}
                  type="button"
                  onClick={() => setSegment(s)}
                  className={active
                    ? 'px-3 py-2 rounded-lg text-sm text-left border border-indigo-500 bg-indigo-500/20 text-white'
                    : 'px-3 py-2 rounded-lg text-sm text-left border border-white/10 bg-white/5 text-gray-400 hover:border-white/30'
                  }
                >
                  {s}
                </button>
              )
            })}
          </div>
        </div>
        <button
          type="submit"
          disabled={loading || !segment || !businessName}
          className="w-full py-3 rounded-xl font-semibold text-white transition-all disabled:opacity-40"
          style={{background:'linear-gradient(135deg,#6366f1,#10b981)'}}
        >
          {loading ? 'Salvando...' : 'Começar a usar →'}
        </button>
      </form>
    </div>
  )
}